var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { getCookie } from '../utils/util';
import { S_REVIEW_LIST_REQUEST, S_REVIEW_LIST_SUCCESS, S_REVIEW_LIST_FAILURE, SET_S_REVIEW_LOADING_STATE, GET_S_REVIEW_INFO, GET_S_REVIEW_INFO_SUCCESS, GET_S_REVIEW_INFO_FAILURE, } from '../reducers/shoppingReview';
var API2_URL = process.env.REACT_APP_API2_URL;
function reviewListAPI(_a) {
    var item_id = _a.item_id, page = _a.page, sort = _a.sort, marks = _a.marks;
    var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/market/reviews");
    var config = {
        withCredentials: true,
        headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
        params: {
            page: page,
            sort: sort,
            marks: marks,
        }
    };
    return axios.get(url, config);
}
function reviewInfoAPI(_a) {
    var item_id = _a.item_id;
    var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/market/reviews/info");
    var config = {
        headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
        withCredentials: true,
    };
    return axios.get(url, config);
}
function reviewList(action) {
    var result, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put({ type: SET_S_REVIEW_LOADING_STATE, payload: true })
                // 상품평 리스트 불러올때 로딩바 처리 UI 소스 경로 -> src/detail/components/review/index.tsx -> ReviewLoading
            ]; //로딩 true
            case 1:
                _a.sent(); //로딩 true
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, , 9]);
                return [4 /*yield*/, call(reviewListAPI, action.payload)
                    // console.log("@@@@@@@@@쇼핑몰 상품평 리스트 응답",result, typeof result?.data)
                ];
            case 3:
                result = _a.sent();
                // console.log("@@@@@@@@@쇼핑몰 상품평 리스트 응답",result, typeof result?.data)
                return [4 /*yield*/, put({
                        type: S_REVIEW_LIST_SUCCESS,
                        data: result === null || result === void 0 ? void 0 : result.data,
                    })];
            case 4:
                // console.log("@@@@@@@@@쇼핑몰 상품평 리스트 응답",result, typeof result?.data)
                _a.sent();
                return [4 /*yield*/, put({ type: SET_S_REVIEW_LOADING_STATE, payload: false })]; //로딩 false
            case 5:
                _a.sent(); //로딩 false
                return [3 /*break*/, 9];
            case 6:
                e_1 = _a.sent();
                console.error(e_1);
                return [4 /*yield*/, put({
                        type: S_REVIEW_LIST_FAILURE,
                    })];
            case 7:
                _a.sent();
                return [4 /*yield*/, put({ type: SET_S_REVIEW_LOADING_STATE, payload: false })]; //로딩 false
            case 8:
                _a.sent(); //로딩 false
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function reviewInfo(action) {
    var result, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put({ type: SET_S_REVIEW_LOADING_STATE, payload: true })
                // 상품평 리스트 불러올때 로딩바 처리 UI 소스 경로 -> src/detail/components/review/index.tsx -> ReviewLoading
            ]; //로딩 true
            case 1:
                _a.sent(); //로딩 true
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, , 9]);
                return [4 /*yield*/, call(reviewInfoAPI, action.payload)
                    // console.log("@@@@@@@@@쇼핑몰 상품평 정보 응답",result, typeof result?.data)
                ];
            case 3:
                result = _a.sent();
                // console.log("@@@@@@@@@쇼핑몰 상품평 정보 응답",result, typeof result?.data)
                return [4 /*yield*/, put({
                        type: GET_S_REVIEW_INFO_SUCCESS,
                        data: result === null || result === void 0 ? void 0 : result.data,
                    })];
            case 4:
                // console.log("@@@@@@@@@쇼핑몰 상품평 정보 응답",result, typeof result?.data)
                _a.sent();
                return [4 /*yield*/, put({ type: SET_S_REVIEW_LOADING_STATE, payload: false })]; //로딩 false
            case 5:
                _a.sent(); //로딩 false
                return [3 /*break*/, 9];
            case 6:
                e_2 = _a.sent();
                console.error(e_2);
                return [4 /*yield*/, put({
                        type: GET_S_REVIEW_INFO_FAILURE,
                    })];
            case 7:
                _a.sent();
                return [4 /*yield*/, put({ type: SET_S_REVIEW_LOADING_STATE, payload: false })]; //로딩 false
            case 8:
                _a.sent(); //로딩 false
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function watchShoppingReviewList() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(S_REVIEW_LIST_REQUEST, reviewList)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(GET_S_REVIEW_INFO, reviewInfo)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default function shoppingReviewSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([fork(watchShoppingReviewList)])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/detail/sagas/shoppingReview.ts
// module id = 165
// module chunks = 0